module.exports = __webpack_public_path__ + "img/step3-1.fe62919e.png";